<template>
    <div>
        <v-col cols="12" md="5">
            <v-select
                :disabled="loading"
                v-model="frequencySelected"
                :items="frequency"
                item-text="description"
                item-value="value"
                label="Periodicidade"
                :rules="[rules.required]"
                @change="getAnalyticsList"
            >
            </v-select>
        </v-col>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="desserts"
                        :loading="loading"
                        loading-text="Carregando..."
                    >
                        <template v-slot:item.total_subscribers="{ item }">
                            <span>{{formatterDecimal.format(item.total_subscribers)}}</span>
                        </template>
                        <template v-slot:item.views="{ item }">
                            <span>{{formatterDecimal.format(item.views)}}</span>
                        </template>
                        <template v-slot:item.total_views="{ item }">
                            <span>{{formatterDecimal.format(item.total_views)}}</span>
                        </template>
                        <template v-slot:item.channel_estimated_revenue="{ item }">
                            <span>{{formatterMoney.format(item.channel_estimated_revenue)}}</span>
                        </template>
                        <template v-slot:item.estimated_net_revenue="{ item }">
                            <span>{{formatterMoney.format(item.estimated_net_revenue)}}</span>
                        </template>
                        <template v-slot:item.advertisement_revenue="{ item }">
                            <span>{{formatterMoney.format(item.advertisement_revenue)}}</span>
                        </template>
                        <template v-slot:item.cms_estimated_revenue="{ item }">
                            <span>{{formatterMoney.format(item.cms_estimated_revenue)}}</span>
                        </template>
                        <template v-slot:item.estimated_revenue="{ item }">
                            <span>{{formatterMoney.format(item.estimated_revenue)}}</span>
                        </template>
                        <template v-slot:item.rpm="{ item }">
                            <span>{{formatterDecimal.format(item.rpm)}}</span>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" class="border">
                <span class="grey--text text--darken-2 subtitle-1">Performance</span>
            </v-col>
            <v-col md="3" sm="12">
                <div class="elevation-2 white d-flex justify-space-around pa-4 align-center">
                    <img src="../assets/icons/cards/subscribers.svg" alt="" width="64">
                    <div class="d-flex flex-column align-center">
                        <span class="grey--text text--darken-2 body-2">Inscritos</span>
                        <span class="grey--text text--darken-3 subtitle-1 font-weight-bold">{{!subscribers ? '--' : formatterDecimal.format(subscribers)}}</span>
                    </div>
                </div>
            </v-col>
            <v-col md="3" sm="12">
                <div class="elevation-2 white d-flex justify-space-around pa-4 align-center">
                    <img src="../assets/icons/cards/videos.svg" alt="" width="64">
                    <div class="d-flex flex-column align-center">
                        <span class="grey--text text--darken-2 body-2">Publicações</span>
                        <span class="grey--text text--darken-3 subtitle-1 font-weight-bold">{{!uploads ? '--' : formatterDecimal.format(uploads)}}</span>
                    </div>
                </div>
            </v-col>
            <v-col md="3" sm="12">
                <div class="elevation-2 white d-flex justify-space-around pa-4 align-center">
                    <img src="../assets/icons/cards/views.svg" alt="" width="64">
                    <div class="d-flex flex-column align-center">
                        <span class="grey--text text--darken-2 body-2">Visualizações</span>
                        <span class="grey--text text--darken-3 subtitle-1 font-weight-bold">{{!views ? '--' : formatterDecimal.format(views)}}</span>
                    </div>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" class="border">
                <span class="grey--text text--darken-2 subtitle-1">Financeiro</span>
            </v-col>
            <v-col md="4" sm="12">
                <div class="elevation-2 white d-flex justify-space-around pa-4 align-center">
                    <img src="../assets/icons/cards/recepit.svg" alt="" width="64">
                    <div class="d-flex flex-column align-center">
                        <span class="grey--text text--darken-2 body-2">Receita Bruta do Canal</span>
                        <span class="grey--text text--darken-3 subtitle-1 font-weight-bold">{{!channel_revenue ? '--' : formatterMoney.format(channel_revenue)}}</span>
                    </div>
                </div>
            </v-col>
            <v-col md="4" sm="12">
                <div class="elevation-2 white d-flex justify-space-around pa-4 align-center">
                    <img src="../assets/icons/cards/money-delivery.svg" alt="" width="64">
                    <div class="d-flex flex-column align-center">
                        <span class="grey--text text--darken-2 body-2">Receita Publicidade</span>
                        <span class="grey--text text--darken-3 subtitle-1 font-weight-bold">{{!advertisement_revenue ? '--' : formatterMoney.format(advertisement_revenue)}}</span>
                    </div>
                </div>
            </v-col>
            <v-col md="4" sm="12">
                <div class="elevation-2 white d-flex justify-space-around pa-4 align-center">
                    <img src="../assets/icons/cards/viewers-compare-money.svg" alt="" width="64">
                    <div class="d-flex flex-column align-center">
                        <span class="grey--text text--darken-2 body-2">Receita Grupos de Assets</span>
                        <span class="grey--text text--darken-3 subtitle-1 font-weight-bold">{{!cms_revenue ? '--' : formatterMoney.format(cms_revenue)}}</span>
                    </div>
                </div>
            </v-col>
            <v-col md="6" sm="12">
                <div class="elevation-2 white d-flex justify-space-around pa-4 align-center">
                    <img src="../assets/icons/cards/money-coin.svg" alt="" width="64">
                    <div class="d-flex flex-column align-center">
                        <span class="grey--text text--darken-2 body-2">Receita Total Bruta</span>
                        <span class="grey--text text--darken-3 subtitle-1 font-weight-bold">{{!total_revenue ? '--' : formatterMoney.format(total_revenue)}}</span>
                    </div>
                </div>
            </v-col>
            <v-col md="6" sm="12">
                <div class="elevation-2 white d-flex justify-space-around pa-4 align-center">
                    <img src="../assets/icons/cards/money-coin.svg" alt="" width="64">
                    <div class="d-flex flex-column align-center">
                        <span class="grey--text text--darken-2 body-2">Receita Total Líquida</span>
                        <span class="grey--text text--darken-3 subtitle-1 font-weight-bold">{{!total_net_revenue ? '--' : formatterMoney.format(total_net_revenue)}}</span>
                    </div>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import moment from 'moment'

export default {
     props: {
        channel: {
            type: Number,
            required: true,
            default: null
        },
        dateIni: {
            type: String,
            required: true,
            default: null
        },
        dateEnd: {
            type: String,
            required: true,
            default: null
        }
    },
    created() {
      this.getAnalyticsList();
      this.getAnalyticsCards();
    },
    data: () => ({
        loading: true,
        moment: moment,
        formatterMoney: new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}),
        formatterDecimal: new Intl.NumberFormat('pt-BR', {currency: 'BRL'}),
        headers: [
          { text: 'Data', align: 'center', sortable: true, value: 'date' },
          { text: 'Dias Pós-aquisição', align: 'center', sortable: false, value: 'days_after_purchase' },
          { text: 'Inscritos na Data', value: 'subscribers', sortable: false, align: 'center' },
          { text: '% Cresc. Inscritos', value: 'pct_growth_subscribers', sortable: false, align: 'center' },
          { text: 'Inscritos Total', value: 'total_subscribers', sortable: false, align: 'center' },
          { text: 'Vis. na Data', value: 'views', sortable: false, align: 'center' },
          { text: '% Cresc. Visualizações', value: 'pct_growth_views', align: 'center', sortable: false },
          { text: 'Vis. Totais', value: 'total_views', sortable: false, align: 'center' },
          { text: 'Receita Canal', value: 'channel_estimated_revenue', sortable: false, align: 'center' },
          { text: 'Receita Grupos de Assets', value: 'cms_estimated_revenue', sortable: false, align: 'center' },
          { text: 'Receita de Publicidade', value: 'advertisement_revenue', sortable: false, align: 'center' },
          { text: 'Receita Total Bruta na Data', value: 'estimated_revenue', sortable: false, align: 'center' },
          { text: 'Receita Total Líquida na Data', value: 'estimated_net_revenue', sortable: false, align: 'center' },
          { text: '% Cresc. Receita', value: 'pct_growth_revenue', sortable: false, align: 'center' },
          { text: 'RPM', value: 'rpm', sortable: false, align: 'center' },
        ],
        rules: {
            required: value => !!value || 'Este campo é obrigatório.'
        },
        frequency: [
            {
                value: 'day',
                description: 'Diário'
            },
            {
                value: 'week',
                description: 'Semanal'
            },
            {
                value: 'month',
                description: 'Mensal'
            }
        ],
        frequencySelected: 'day',
        desserts: [],
        subscribers: '',
        uploads: '',
        views: '',
        channel_revenue: '',
        advertisement_revenue: '',
        cms_revenue: '',
        total_revenue: '',
        total_net_revenue: ''
    }),
    methods: {
        getAnalyticsList() {
            this.loading = true;
            this.$http.get( '/analytics/channel/'+this.channel+'/report?aggregation='+this.frequencySelected+'&start_date='+this.dateIni+'&end_date='+this.dateEnd )
            .then( ( res ) => {
                this.desserts = res.data;
                this.loading = false;
            })
        },
        getAnalyticsCards() {
            this.$http.get( '/analytics/channel/'+this.channel+'/report/cards?start_date='+this.dateIni+'&end_date='+this.dateEnd )
            .then( ( res ) => {
                this.subscribers = res.data.subscribers
                this.uploads = res.data.uploads
                this.views = res.data.views
                this.channel_revenue = res.data.channel_revenue
                this.advertisement_revenue = res.data.advertisement_revenue
                this.cms_revenue = res.data.cms_revenue
                this.total_revenue = res.data.total_revenue
                this.total_net_revenue = res.data.total_net_revenue
            })
        }
    }
}
</script>

<style scoped>
  .d-content {
    display: contents !important;
  }
  .table-min-height {
    min-height: 60vh;
  }
  .border {
        border-bottom: 1px solid #f3f3f3;
    }
</style>